var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import S from 's-js';
import * as Surplus from "surplus";
import { Page } from "./Page";
import { Loading } from './Loading';
import { ArticlesToggle, PaginatedArticleFeed } from './ArticlesFeed';
export { HomeRoute };
const HomeRoute = (app) => __awaiter(this, void 0, void 0, function* () {
    const model = HomeModel(app);
    return () => <HomePage {...model}/>;
}), HomeModel = (app) => {
    const tab = S.data(S.sample(app.isAuthenticated) ? 'your' : 'all'), // 'your' | 'all' | '#tag'
    tag = () => tab()[0] === '#' ? tab().substr(1) : undefined, feed = () => {
        const endpoint = tab() === 'your' ? app.client.feed : app.client.articles, filter = tag() ? { tag: tag() } : {};
        return (q) => endpoint.get(Object.assign({}, q, filter));
    }, tags = app.client.tags.get();
    return { app, tab, tag, feed, tags };
}, HomePage = (model) => (<Page app={model.app} title="Home - Conduit" section={0 /* Home */}>
            <Home {...model}/>
        </Page>), Home = ({ tab, tag, feed, tags, app: { isAuthenticated, client } }) => (<div class="home-page">
            <div class="banner" hidden={isAuthenticated()}>
                <div class="container">
                    <h1 class="logo-font">conduit</h1>
                    <p>A place to share your knowledge.</p>
                </div>
            </div>

            <div class="container page">
                <div class="row">
                    <div class="col-md-9">
                        <ArticlesToggle tab={tab}>{Object.assign({}, (isAuthenticated() ? { your: 'Your Feed ' } : {}), { all: 'Global Feed' }, (tag() ? { [tab()]: [<i class="ion-pound"/>, " ", tag()] } : {}))}</ArticlesToggle>

                        <PaginatedArticleFeed size={10} feed={feed()} client={client}/>
                    </div>

                    <div class="col-md-3">
                        <div class="sidebar">
                            <p>Popular Tags</p>

                            <Loading task={() => tags} placeholder="Loading tags...">
                                {data => <div class="tag-list">
                                        {data.tags.map(tag => <a href="" class="tag-pill tag-default" onClick={() => (tab('#' + tag), false)}>
                                                {tag}
                                            </a>)}
                                    </div>}
                            </Loading>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
